import React, { useState } from 'react';
import './youtube_player.css'

const YoutubePlayer = () => {
    let youtubeID = window.location.search.toString()
    youtubeID = youtubeID.substring(4,youtubeID.length)

    const [showLoader,setShowLoader] = useState(true)

    return (
        <div className='player'>
            {showLoader &&(
                <>
                    <div className='video_loader' style={{left:((parseInt(window.screen.width.toString())-360)/2).toString()+'px'}}></div>
                    <div class="lds-spinner" style={{left:((parseInt(window.screen.width.toString())-80)/2).toString()+'px'}}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                </>
            )}
            <iframe
                onLoad={()=>setShowLoader(false)}
                width="360" height="240"
                src={"https://www.youtube.com/embed/"+youtubeID}
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen>
            </iframe>
        </div>
    );
};

export default YoutubePlayer;